export default __webpack_public_path__ + "static/case-study1-27589bef4a806ace7d5161c97f4f80cb.jpg";